import { Skeleton } from '@automata/run-visualizer';
import { LinearProgress } from '@mui/material';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import CancelPlanningModalButton from './CancelPlanningModalButton';

export type Props = {
  planId: string;
  stageDetail?: string | null;
};

const AwaitingPreviewDisplay = ({ planId, stageDetail }: Props) => {
  return (
    <Stack p={3}>
      <LinearProgress
        sx={{ width: '100%', height: '4px' }}
        aria-label="Creating plan"
      />
      <Stack justifyContent="center" alignItems="center" paddingY={4} gap={2}>
        <Typography variant="h4" component="h2">
          Busy planning. Hold tight!
        </Typography>
        <Typography variant="subtitle1" component="h3" aria-live="polite">
          {stageDetail ||
            "We're crafting your plan. It might take as long as finding a matching sock!"}
        </Typography>

        <CancelPlanningModalButton planId={planId} />
      </Stack>
      <Skeleton />
    </Stack>
  );
};

export default AwaitingPreviewDisplay;
